import { RasterTileSource } from "maplibre-gl";
import { Basemap } from "./BasemapSelectorStore";
import { CommentMapUtilOptimized } from "~/components/Map/Comment/CommentMapUtilOptimized";
import { MemberMapUtilOptimized } from "~/components/Map/Member/MemberMapUtilOptimized";
import { ElementMapUtilOptimized } from "~/components/Map/Element/ElementMapUtilOptimized";
import CollectItemsMapUtils from "~/components/Map/utils/CollectItemsMapUtils";
import FreePhotoVectorTileUtils from "~/components/Map/utils/FreePhotoVectorTileUtils";
import CollectPhotoVectorTileUtils from "~/components/Map/utils/CollectPhotoVectorTileUtils";

export const BasemapMapUtil = {

  // Helper function to clear all map utility caches
  clearAllMapCaches: () => {
    console.log('BasemapMapUtil - Clearing all map caches');
    CommentMapUtilOptimized.private_commentsOnMap.clear();
    CommentMapUtilOptimized.private_commentHashes.clear();
    CommentMapUtilOptimized.private_bitmapCache.clear();

    MemberMapUtilOptimized.private_membersOnMap.clear();
    MemberMapUtilOptimized.private_memberHashes.clear();
    MemberMapUtilOptimized.private_bitmapCache.clear();

    ElementMapUtilOptimized.private_elementsOnMap.clear();
    ElementMapUtilOptimized.private_elementHashes.clear();
  },

  changeBasemap: (basemap: Basemap) => {
    const map = window.map;
    if (!map) {
      return;
    }

    if (basemap.type === 'google') {

      const rasterSource = map.getSource<RasterTileSource>('basemap-layer');

      // setup basemap
      if (!rasterSource) {
        map.addSource('basemap-layer', {
          type: 'raster',
          tiles: [basemap.url],
          tileSize: 256,
          maxzoom: 22,
        });
        map.addLayer({
          id: 'basemap-layer',
          type: 'raster',
          source: 'basemap-layer',
          minzoom: 0,
        });
        map.moveLayer('basemap-layer', '');
      } else {
        const layers = map.getStyle()?.layers || [];
        layers.forEach((layer: any) => {
          if (layer.type === 'raster' && layer.source === 'raster-tiles') {
            map.removeLayer(layer.id);
          }
        });
        rasterSource.setTiles([basemap.url]);
      }

      // For google basemap changes, manually clear caches and trigger re-render
      BasemapMapUtil.clearAllMapCaches();

      // Force controller re-render by dispatching a custom event
      window.dispatchEvent(new CustomEvent('basemapChanged'));

    } else if (basemap.type === 'maptiler') {
      // Remove vector tile layers before changing style to prevent errors
      CollectItemsMapUtils.removeFromMap();
      FreePhotoVectorTileUtils.removeFromMap();
      CollectPhotoVectorTileUtils.removeFromMap();

      // Re-add layers after style is fully loaded
      const onStyleLoad = () => {
        CollectItemsMapUtils.addToMap();
        CollectItemsMapUtils.moveLayerToTop();
        FreePhotoVectorTileUtils.addToMap();
        FreePhotoVectorTileUtils.moveLayerToTop();
        CollectPhotoVectorTileUtils.addToMap();
        CollectPhotoVectorTileUtils.moveLayerToTop();

        map.off('style.load', onStyleLoad);
      };
      // Currently, this event is not working as expected, so we also add a fallback timeout to ensure layers are re-added
      map.on('style.load', onStyleLoad);

      map.setStyle(basemap.url);
      setTimeout(() => {
        onStyleLoad();
      }, 1000); // Fallback in case style.load doesn't fire

      window.dispatchEvent(new CustomEvent('basemapChanged'));
    }
  }
}